import { mapGradient } from './mappers.util.js';

var mapBackgroundImage = function mapBackgroundImage(backgroundImage) {
  if (!backgroundImage) {
    return undefined;
  }
  return backgroundImage;
};
var mapBackgroundImageAndGradient = function mapBackgroundImageAndGradient(direction, theme, backgroundColorProps, backgroundImageProps, intent) {
  var backgroundImage = [mapGradient(backgroundColorProps, direction, theme, intent), mapBackgroundImage(backgroundImageProps)].filter(function (b) {
    return b;
  }).join(',');
  return backgroundImage ? {
    backgroundImage: backgroundImage
  } : {};
};

export { mapBackgroundImageAndGradient };
//# sourceMappingURL=background.js.map
